import './styles.scss';
import React, { ReactNode } from 'react';

interface CollapsibleToolbarComponentProps {
    isOpen: boolean;
    collapseIcon: JSX.Element;
    position: 'bottom' | 'right' | 'left';
    className?: string;
    contentClassName?: string;
    children?: ReactNode;
    toggle: () => void;
    onTransitionStart?: () => void;
    onTransitionEnd?: (event: React.TransitionEvent<HTMLDivElement>) => void;
}
export class CollapsibleToolbarComponent extends React.Component<CollapsibleToolbarComponentProps> {
    public render(): JSX.Element {
        return (
            <div
                className={`collapisbleContainer ${this.props.position} ${this.props.isOpen ? 'visible' : 'hidden'} ${
                    this.props.className
                }`}
                onTransitionEnd={e => this.props.onTransitionEnd && this.props.onTransitionEnd(e)}
            >
                <button className="collapser" onClick={() => this.onCollapserClick()}>
                    {this.props.collapseIcon}
                </button>
                <div
                    className={`collapsibleContent ${this.props.contentClassName || ''} ${
                        this.props.isOpen ? 'visible' : 'hidden'
                    }`}
                >
                    {this.props.children}
                </div>
            </div>
        );
    }

    private onCollapserClick() {
        this.props.toggle();
        this.props.onTransitionStart && this.props.onTransitionStart();
    }
}
